import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { AvatarDataSource } from "@/app/types/client-avatar/ClientAvatar";

export function getTranslatedSource(source: string, t: TFn): string {
  if (!source) return t(TKey.AVATAR_DATA_SOURCE_MANUAL) as string;

  switch (source.toUpperCase()) {
    case AvatarDataSource.MANUAL:
      return t(TKey.AVATAR_DATA_SOURCE_MANUAL) as string;
    case AvatarDataSource.AI:
      return t(TKey.AVATAR_DATA_SOURCE_AI) as string;
    case AvatarDataSource.CALLS:
      return t(TKey.AVATAR_DATA_SOURCE_CALLS) as string;
    case AvatarDataSource.COMMUNITIES:
      return t(TKey.AVATAR_DATA_SOURCE_COMMUNITIES) as string;
    case AvatarDataSource.SURVEYS:
      return t(TKey.AVATAR_DATA_SOURCE_SURVEYS) as string;
    case AvatarDataSource.SUPPORT:
      return t(TKey.AVATAR_DATA_SOURCE_SUPPORT) as string;
    case AvatarDataSource.COMPETITORS:
      return t(TKey.AVATAR_DATA_SOURCE_COMPETITORS) as string;
    case AvatarDataSource.OTHER:
      return t(TKey.AVATAR_DATA_SOURCE_OTHER) as string;
    default:
      return source;
  }
}
